import { Component, ViewChild, Input, ContentChild, TemplateRef, AfterContentInit } from '@angular/core';
import { IStep } from '../ngx-bootstrap-product-tour.models';
import { NgxBootstrapProductTourStepService } from './ngx-bootstrap-product-tour-step.service';
import { NgxBootstrapProductTourService } from '../ngx-bootstrap-product-tour.service';
export class NgxBootstrapProductTourStepComponent implements AfterContentInit {
public defaultTourStepTemplate: TemplateRef<any>;
public stepTemplate: TemplateRef<{ step: IStep }>;
/**
 * @param {?} ngxBootstrapProductTourStepService
 * @param {?} tourService
 */
constructor(
private ngxBootstrapProductTourStepService: NgxBootstrapProductTourStepService,
public tourService: NgxBootstrapProductTourService) { }
/**
 * @return {?}
 */
public ngAfterContentInit(): void {
    this.ngxBootstrapProductTourStepService.template = this.stepTemplate || this.defaultTourStepTemplate;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-bootstrap-product-tour',
  template: `
    <div *ngIf="tourService.currentStep?.backdrop && tourService.isStepOpen(tourService.currentStep)" class="tour-backdrop"></div>
      <ng-template #tourStep>
      <p class="tour-step-content">{{tourService.currentStep.content}}</p>
      <div class="tour-step-navigation">
        <button *ngIf="tourService.hasPrev(tourService.currentStep)" class="btn btn-sm btn-default" (click)="tourService.prev()">« Prev</button>
        <button *ngIf="tourService.hasNext(tourService.currentStep)" class="btn btn-sm btn-default" (click)="tourService.next()">Next »</button>
        <button class="btn btn-sm btn-error" (click)="tourService.end()">End</button>
      </div>
    </ng-template>
  `,
  styles: [`
    ::ng-deep .orphan {
        position: fixed;
        top: 50% !important;
        left: 50% !important;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    ::ng-deep .orphan>.popover-arrow {
        display: none;
    }

    .tour-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgxBootstrapProductTourStepService, },
{type: NgxBootstrapProductTourService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'defaultTourStepTemplate': [{ type: ViewChild, args: ['tourStep', { read: TemplateRef }, ] },],
'stepTemplate': [{ type: Input },{ type: ContentChild, args: [TemplateRef, ] },],
};
}

function NgxBootstrapProductTourStepComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxBootstrapProductTourStepComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxBootstrapProductTourStepComponent.ctorParameters;
/** @type {?} */
NgxBootstrapProductTourStepComponent.propDecorators;
/** @type {?} */
NgxBootstrapProductTourStepComponent.prototype.defaultTourStepTemplate;
/** @type {?} */
NgxBootstrapProductTourStepComponent.prototype.stepTemplate;
/** @type {?} */
NgxBootstrapProductTourStepComponent.prototype.ngxBootstrapProductTourStepService;
/** @type {?} */
NgxBootstrapProductTourStepComponent.prototype.tourService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
